<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <defs>
      <path
        id="star-outline-path-1"
        d="M10,0.352163462 C10.2764423,0.352163462 10.4807692,0.615553506 10.5889423,0.843026726 L10.5889423,0.843026726 L13.2932692,6.29041173 L19.3269231,7.16438778 C19.6153846,7.21227688 20,7.35594418 20,7.71511242 C20,7.93061337 19.84375,8.13414204 19.6875,8.28978161 L19.6875,8.28978161 L15.3245192,12.5279669 L16.3581731,18.5141042 C16.3701923,18.5979102 16.3701923,18.6697438 16.3701923,18.7535497 C16.3701923,19.0648289 16.2259615,19.3521635 15.8774038,19.3521635 C15.7091346,19.3521635 15.5408654,19.2923021 15.3966346,19.2084962 L15.3966346,19.2084962 L10,16.3830393 L4.60336538,19.2084962 C4.44711538,19.2923021 4.29086538,19.3521635 4.12259615,19.3521635 C3.77403846,19.3521635 3.61778846,19.0648289 3.61778846,18.7535497 C3.61778846,18.6697438 3.62980769,18.5979102 3.64182692,18.5141042 L3.64182692,18.5141042 L4.67548077,12.5279669 L0.300480769,8.28978161 C0.15625,8.13414204 0,7.93061337 0,7.71511242 C0,7.35594418 0.372596154,7.21227688 0.673076923,7.16438778 L0.673076923,7.16438778 L6.70673077,6.29041173 L9.41105769,0.843026726 C9.51923077,0.615553506 9.72355769,0.352163462 10,0.352163462 Z M10,4 C9.82540486,4 9.69635628,4.16635161 9.62803644,4.3100189 L7.92004049,7.75047259 L4.10931174,8.30245747 C3.91953441,8.33270321 3.68421053,8.42344045 3.68421053,8.65028355 C3.68421053,8.78638941 3.78289474,8.91493384 3.87398785,9.01323251 L6.63714575,11.6899811 L5.98431174,15.4706994 C5.97672065,15.5236295 5.96912955,15.5689981 5.96912955,15.6219282 C5.96912955,15.8185255 6.06781377,16 6.28795547,16 C6.39423077,16 6.49291498,15.9621928 6.59159919,15.9092628 L10,14.1247637 L13.4084008,15.9092628 C13.4994939,15.9621928 13.6057692,16 13.7120445,16 C13.9321862,16 14.0232794,15.8185255 14.0232794,15.6219282 C14.0232794,15.5689981 14.0232794,15.5236295 14.0156883,15.4706994 L13.3628543,11.6899811 L16.1184211,9.01323251 C16.2171053,8.91493384 16.3157895,8.78638941 16.3157895,8.65028355 C16.3157895,8.42344045 16.0728745,8.33270321 15.8906883,8.30245747 L12.0799595,7.75047259 L10.3719636,4.3100189 C10.3036437,4.16635161 10.1745951,4 10,4 Z"
      ></path>
    </defs>
    <g id="Icon-Star-Outline" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Mask/LS_Green">
        <mask id="star-outline-mask-2" fill="white">
          <use xlink:href="#star-outline-path-1"></use>
        </mask>
        <use
          id="Combined-Shape"
          :fill="color"
          fill-rule="nonzero"
          xlink:href="#star-outline-path-1"
        ></use>
        <g id="Rectangle" mask="url(#star-outline-mask-2)" :fill="color">
          <rect x="0" y="0" width="20" height="20"></rect>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'StarSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>
